// api/mrtApi.js
import { api } from "./CustomAPI"

/* -------- Generic MRT fetcher -------- */

export const fetchPublicMRTData = async (
  endpoint,
  params,
  signal,
) => {
  if (!endpoint) {
    throw new Error('MRT endpoint is required');
  }

  const { ...restParams } = params;

  const cleanParams = Object.fromEntries(
    Object.entries(restParams).filter(
      ([_, value]) => value !== undefined && value !== null && value !== ''
    )
  );

  const response = await api.get(endpoint, {
    params: cleanParams,
    signal,
    skipInterceptor: false,
  });

return {
    data: response.data?.ajhData,
    totalRows: response.data?.lastRow,
  };
};